import { Trans } from "react-i18next";

import UploadImage from "@components/UploadImage";
import Modal from "@src/ui/Modal";
import { CommonButton } from "@components/CommonButton";

import { useShowLoginLimitModal } from "./hooks";

const LoginLimitModal = () => {
  const { showLoginLimitModal, setShowLoginLimitModal, loginLimitNumber } = useShowLoginLimitModal();
  if (!showLoginLimitModal) return null;
  return (
    <Modal
      className="!w-[412px]"
      open={showLoginLimitModal}
      footer={false}
      onCancel={() => setShowLoginLimitModal(false)}
    >
      <div className="flex flex-col items-center justify-center !w-[412px] py-[16px] relative">
        <UploadImage name="806e179f.png" className="h-[71px] absolute top-0 left-0 right-0"></UploadImage>
        <UploadImage name="99a37b4b.webp" className="w-[64px] h-[48px]"></UploadImage>
        <div className="mt-[8px] mb-[12px] px-[44px] flex flex-col items-center">
          <div className="text-left leading-[24px]  ">
            <Trans i18nKey={"LoginLimitAccount"} values={{ loginLimitTime: loginLimitNumber }}>
              Sorry, your account has reached today's device limit(5). Please wait until
              <b className="text-kds-accent">{{ loginLimitTime: loginLimitNumber } as any}</b> then try to log in again.
            </Trans>
          </div>
        </div>
        <CommonButton
          className="px-[24px]  min-w-[133px] h-[34px]"
          type="primary"
          onClick={() => setShowLoginLimitModal(false)}
        >
          <Trans>Got It</Trans>
        </CommonButton>
      </div>
    </Modal>
  );
};
export default LoginLimitModal;
